module.exports = __webpack_public_path__ + "static/account-protection-hero-mobile.72e8eb1d.webp";